import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, MapIcon, TimerIcon, UtensilsIcon, CheckSquareIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: 'Guía Maestra Protocolo SOS',
  description: 'El manual paso a paso para identificar qué órgano te está despertando.'
}, {
  icon: MapIcon,
  title: 'Mapa de Puntos Maestros',
  description: 'Localización exacta de los 3 puntos de presión que inducen el sueño profundo.'
}, {
  icon: TimerIcon,
  title: 'El Ritual de 12 Minutos',
  description: 'La secuencia exacta de presiones y respiración sonora para apagar la mente.'
}, {
  icon: UtensilsIcon,
  title: 'Manual de Dieta Térmica',
  description: 'Qué comer y qué evitar para no "encender" tu cerebro por la noche.'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist de Auditoría Nocturna',
  description: 'Para asegurar que tu habitación sea un templo de energía Yin.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-navy-800 px-4 py-20" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-150">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-151">
            Qué Obtienes
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-152"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-153">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-navy-900 border border-gold/20 rounded-lg p-6 hover:border-gold/50 transition-colors" data-id="element-154">
              <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mb-4" data-id="element-155">
                <item.icon className="w-7 h-7 text-gold" data-id="element-156" />
              </div>
              <h3 className="font-serif text-xl text-white mb-3" data-id="element-157">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-158">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-159">
          <motion.a href="#oferta" whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(212, 175, 55, 0.5)'
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold text-navy-900 font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 cursor-pointer" data-id="element-160">
            ¡QUIERO DORMIR BIEN AHORA!
          </motion.a>
        </motion.div>
      </div>
    </section>;
}